<template>
	<BaseBanner :condition="isInvalidShipping">
		<p>
			We can only ship this product to the United States of America or
			Canada please update your shipping address to continue.
		</p>
	</BaseBanner>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseBanner from './index.vue';

export default {
	components: { BaseBanner },
	computed: mapGetters('checkout', ['isInvalidShipping']),
};
</script>
